export const ANIMATION_PAGE_ENTER_DELAY = 0.7; // secondes
export const ANIMATION_PAGE_ENTER_DELAY_MILI = 700; // secondes
export const ANIMATION_TITLES_INCREMENT = 0.035;
export const ANIMATION_TEXT_INCREMENT = 0.008;
export const ANIMATION_GLOBAL_OFFSET = 0.15;